import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTableSelector } from '@/common/ui/table/data-table-selector'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { GetBatchesDataResponse } from '../../type'
import { columns } from './constants'
import CreateBatchDialog from '../CreateBatchDialog'

interface BatchTableProps {
	data: GetBatchesDataResponse[]
	total: number
	isLoading?: boolean
}

export default function BatchTable({
	data,
	total,
	isLoading,
}: BatchTableProps) {
	const statusOptions = [
		{ label: 'เปิดใช้งาน', value: 'ACTIVE' },
		{ label: 'ปิดใช้งาน', value: 'INACTIVE' },
	]

	return (
		<div className="space-y-4">
			<div className="flex items-center justify-between">
				<div className="flex flex-wrap items-center gap-4">
					<DataTableSelector
						options={statusOptions}
						placeholder="เลือกสถานะ"
						label="สถานะ"
					/>
					<DataTableSearch placeHolder="ค้นหาด้วยชื่อชุดคูปอง" />
					<DataTableResetFilter />
				</div>
				<CreateBatchDialog />
			</div>
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
